import type { NavbarItem } from './types';

export type NavSection = { label: string; items: NavbarItem[]; hideLabel?: boolean };

// Organize only entries already authorized by useNavbarItems. Missing entries
// can be closed betas or staff permissions; never synthesize activation links.
const SECTION_ORDER = [
  { label: 'Día a día', labels: ['Inicio', 'Agenda', 'Conversaciones', 'Clientes'] },
  { label: 'Tu oferta', labels: ['Mi página', 'Catálogo', 'Servicios', 'Equipo', 'Recursos'] },
  {
    label: 'Crecer',
    labels: [
      'Mensajes automáticos',
      'Descuentos',
      'Ofertas',
      'Reseñas',
      'Tarjetas de regalo',
      'Premios',
      'Fidelización',
      'Comunidad',
      'Contenido IG',
      'Instagram',
      'Promotores'
    ]
  },
  // Orden de JP (19/10): Analítica | Finanzas | Actividad.
  { label: 'Números', labels: ['Analítica', 'Finanzas', 'Caja', 'Actividad', 'Actividad landing'] },
  { label: 'Tu negocio', labels: ['Mi plan', 'Medios de cobro'] }
];
// Grupo fijo de abajo. Ajustes generales vive acá (JP, 19/10), no en «Tu negocio».
const SYSTEM_ORDER = [
  'Ajustes generales',
  'Notificaciones',
  'Referidos',
  'Invitaciones',
  'Mis cursos',
  'Mis comunidades',
  'Tus ideas',
  'Centro de ayuda'
];

export const groupMainNavSections = (
  items: NavbarItem[]
): { sections: NavSection[]; systemItems: NavbarItem[]; rest: NavbarItem[] } => {
  const pool = new Map(items.filter((item) => item.label !== 'Salir').map((item) => [item.label, item]));
  const take = (labels: string[]) =>
    labels.flatMap((label) => {
      const item = pool.get(label);
      pool.delete(label);
      return item ? [item] : [];
    });
  const sections = SECTION_ORDER.map(({ label, labels }) => ({ label, items: take(labels) }));
  const systemItems = take(SYSTEM_ORDER);
  // Preserve uncommon plans and future entries instead of dropping them silently.
  const rest = [...pool.values()];
  return { sections, systemItems, rest };
};
